import { createApi } from '@reduxjs/toolkit/query/react';
import { COGNITO_SERVICE } from 'utils/const';
import {
  getUnassignedMembers,
  getAssignedMembers,
  listUsers,
  listUsersInGroup,
  deleteUser,
  removeUserFromGroup,
  addUserToGroup,
  updateUserAttributes,
} from './cognitoApis';

export const cognitoApi = createApi({
  reducerPath: 'cognitoApi',
  baseQuery: async (args) => {
    const { path } = args;
    switch (path) {
      case COGNITO_SERVICE.PATHS.GET_UNASSIGNED_MEMBERS:
        return getUnassignedMembers(args);
      case COGNITO_SERVICE.PATHS.GET_ASSIGNED_MEMBERS:
        return getAssignedMembers(args);
      case COGNITO_SERVICE.PATHS.LIST_USERS:
        return listUsers(args);
      case COGNITO_SERVICE.PATHS.LIST_USERS_IN_GROUP:
        return listUsersInGroup(args);
      case COGNITO_SERVICE.PATHS.DELETE_USER:
        return deleteUser(args);
      case COGNITO_SERVICE.PATHS.REMOVE_USER_FROM_GROUP:
        return removeUserFromGroup(args);
      case COGNITO_SERVICE.PATHS.ADD_USER_TO_GROUP:
        return addUserToGroup(args);
      case COGNITO_SERVICE.PATHS.UPDATE_USER_ATTRIBUTES:
        return updateUserAttributes(args);

      default:
        return { error: 'path attribute is missing in the arguments!' };
    }
  },
  endpoints: (builder) => ({
    getUnassignedMembers: builder.query({
      query: (args) => ({
        path: COGNITO_SERVICE.PATHS.GET_UNASSIGNED_MEMBERS,
        ...args,
      }),
    }),
    getAssignedMembers: builder.query({
      query: (args) => ({
        path: COGNITO_SERVICE.PATHS.GET_ASSIGNED_MEMBERS,
        ...args,
      }),
    }),
    listUsers: builder.query({
      query: (args) => ({
        path: COGNITO_SERVICE.PATHS.LIST_USERS,
        ...args,
      }),
    }),
    listUsersInGroup: builder.query({
      query: (args) => ({
        path: COGNITO_SERVICE.PATHS.LIST_USERS_IN_GROUP,
        ...args,
      }),
    }),
    deleteUser: builder.mutation({
      query: (args) => ({
        path: COGNITO_SERVICE.PATHS.DELETE_USER,
        ...args,
      }),
      keepUnusedDataFor: 0,
    }),
    removeUserFromGroup: builder.mutation({
      query: (args) => ({
        path: COGNITO_SERVICE.PATHS.REMOVE_USER_FROM_GROUP,
        ...args,
      }),
    }),
    addUserToGroup: builder.mutation({
      query: (args) => ({
        path: COGNITO_SERVICE.PATHS.ADD_USER_TO_GROUP,
        ...args,
      }),
    }),
    updateUserAttributes: builder.mutation({
      query: (args) => ({
        path: COGNITO_SERVICE.PATHS.UPDATE_USER_ATTRIBUTES,
        ...args,
      }),
    }),
  }),
});

export const {
  useGetUnassignedMembersQuery,
  useGetAssignedMembersQuery,
  useListUsersQuery,
  useListUsersInGroupQuery,
  useDeleteUserMutation,
  useAddUserToGroupMutation,
  useRemoveUserFromGroupMutation,
  useUpdateUserAttributesMutation,
} = cognitoApi;
